import React from 'react';
import AvatarPastille from '../AvatarPastille';
import Avatar from '../../types/avatar';

type AvatarOverflowTooltipProps = {
  avatars: Avatar[];
};

const AvatarOverflowTooltip: React.FC<AvatarOverflowTooltipProps> = ({ avatars }) => (
  <div className="avatar-overflow-tooltip">
    {avatars.map(avatar => (
      <div key={avatar._id} className="avatar-overflow-tooltip-item">
        <AvatarPastille avatar={avatar} />
        <span className="avatar-overflow-tooltip-name">
          {avatar.fname} {avatar.lname}
        </span>
      </div>
    ))}
  </div>
);

export default AvatarOverflowTooltip;
